export const cx = (...classes) => classes.filter(Boolean).join(' ');
